import React, { useEffect, useState } from "react";
import {
  Box,
  ButtonStyled,
  FormButtonStyled,
  HeadingStyled,
  LazyImage,
  TextStyled,
} from "../../../components/styled/Elements";
import { ForgetPassImg } from "../../../components/styled/AllImages";
import { Form, Modal } from "react-bootstrap";
import ValidatedInput from "../../../components/common/inputFields/ValidatedInput";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import AuthApi from "../../../services/api/authApi";
import { toast } from "react-toastify";

const ForgetPasswordModal = (props) => {
  const { setEmailSentModalShow } = props;
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const {
    register,
    resetField,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const handleResetRequest = async (credetials) => {
    try {
      setLoading(true);
      const response = await AuthApi.reqPasswordReset(credetials);
      if (response.code === 200) {
        toast.success(response?.message);
        props.onHide();
        setEmailSentModalShow(true);
      }
      if (response.code === 100 || response.code === 204) {
        toast.error(response?.message);
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    resetField("email");
  }, [props.show]);

  return (
    <Modal
      {...props}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Body>
        <Form onSubmit={handleSubmit(handleResetRequest)}>
          <Box className="d-flex flex-column align-items-center py-3 px-2">
            <Box>
              <LazyImage src={ForgetPassImg} />
            </Box>
            <Box>
              <HeadingStyled size="24px" className="mb-2 mt-3">
                {t("forgot_password")}
              </HeadingStyled>
            </Box>
            <Box>
              <TextStyled
                size="16px"
                color="var(--lightGrey)"
                className="text-center px-3 mb-2"
              >
                {t("enter_email_below_to_get_reset_link")}
              </TextStyled>
            </Box>
            <Box className="w-100">
              <ValidatedInput
                name="email"
                label={"email"}
                type="input"
                fieldType="text"
                placeholder={"emailPlaceholder"}
                className={"w-100 mb-3 combined flex-wrap p-0"}
                register={register}
                errors={errors}
                validationRules={{
                  required: true,
                }}
              />
            </Box>
            <FormButtonStyled
              label={t("send")}
              type="submit"
              className="w-100"
              clName="w-100 mb-2"
              isLoading={loading}
              disabled={loading}
            />

            <FormButtonStyled
              label={t("Cancel")}
              className="w-100"
              type="button"
              clName="w-100"
              bg="transparent"
              shadow="false"
              color="var(--lightGrey)"
              onClick={props.onHide}
            />
          </Box>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default ForgetPasswordModal;
